exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-96222906]{margin-bottom:30px;border:0;box-shadow:0 0 .5px 0 rgba(0,0,0,.14),0 1px 1px 0 rgba(0,0,0,.24)}.card .card-header[data-v-96222906]{color:#222;font-size:14px;font-weight:600;border-bottom:none}.card .card-table[data-v-96222906]{padding:1.25rem 0}.card .form-row:last-of-type .form-group[data-v-96222906],.card .row:last-of-type .form-group[data-v-96222906]{margin-bottom:0}.cursor-pointer[data-v-96222906]{cursor:pointer}", ""]);

// exports
